import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["hits", "sendEvent", "hitComponent", "classNames"];
import React from 'react';
import { cx } from "./lib/cx.js";
function DefaultHitComponent(_ref) {
  var hit = _ref.hit;
  return /*#__PURE__*/React.createElement("div", {
    style: {
      wordBreak: 'break-all'
    }
  }, JSON.stringify(hit).slice(0, 100), "\u2026");
}
export function Hits(_ref2) {
  var hits = _ref2.hits,
    sendEvent = _ref2.sendEvent,
    _ref2$hitComponent = _ref2.hitComponent,
    HitComponent = _ref2$hitComponent === void 0 ? DefaultHitComponent : _ref2$hitComponent,
    _ref2$classNames = _ref2.classNames,
    classNames = _ref2$classNames === void 0 ? {} : _ref2$classNames,
    props = _objectWithoutProperties(_ref2, _excluded);
  return /*#__PURE__*/React.createElement("div", _extends({}, props, {
    className: cx('ais-Hits', classNames.root, hits.length === 0 && cx('ais-Hits--empty', classNames.emptyRoot), props.className)
  }), /*#__PURE__*/React.createElement("ol", {
    className: cx('ais-Hits-list', classNames.list)
  }, hits.map(function (hit) {
    return /*#__PURE__*/React.createElement("li", {
      key: hit.objectID,
      className: cx('ais-Hits-item', classNames.item)
    }, /*#__PURE__*/React.createElement(HitComponent, {
      hit: hit,
      sendEvent: sendEvent
    }));
  })));
}